<template>
  <div>
    <div id="search-form-box">
      <search-form-box :main_event_id="main_event_id" :main_event_title="main_event_title" :play_dates="play_dates" :ticket_types="ticket_types" :get_audiences_path="get_audiences_path"></search-form-box>
    </div>
    <!-- チェックボックスコンポーネントとリストコンポーネントを横並びにするためのwrapper -->
    <div class="checkboxes-and-audience-list-table-wrapper">
      <div id="payment-search-checkboxes">
        <payment-search-checkboxes :get_audiences_path="get_audiences_path"></payment-search-checkboxes>
      </div>
      <div id="audience-list-table" class="audience-list-table-wrap">
        <audience-list-table
          :get_audiences_path="get_audiences_path"
          :event_use_introducer="event_use_introducer"
          :event_introducer_text="event_introducer_text"
          :event_questionnaires="event_questionnaires"
          :use_introducer_tell="use_introducer_tell"
          :use_introducer_name="use_introducer_name"
          :use_introducer_adress="use_introducer_adress"
          :send_csv_path="send_csv_path"
          :eventer_mail="eventer_mail"
          :main_event_title="main_event_title"
          :edit_audience_path="edit_audience_path"
          :recapcha_api_key="recapcha_api_key"
          :send_pdf_path="send_pdf_path"
          :refund_message="refund_message"
          :main_event_play_date="main_event_play_date"
          :event_place="event_place"
          :event_url="event_url"
          :contact_info="contact_info"
          :inquiry_url="inquiry_url"
          :main_event_id="main_event_id"
          :is_cooperator="is_cooperator"
          :is_can_not_refund_event="is_can_not_refund_event"
          :exclamation_img_path="exclamation_img_path"
          :comment_img_path="comment_img_path"
          :block_audience_path="block_audience_path"
          :use_contact_form="use_contact_form"
          :contact_mails="contact_mails"
          :contact_tels="contact_tels"
          :contact_urls="contact_urls"
        ></audience-list-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    main_event_id: { type: Number, required: true },
    main_event_title: { type: String, required: true },
    play_dates: { type: Array, required: true },
    ticket_types: { type: Array, required: true },
    get_audiences_path: { type: String, required: true },
    event_use_introducer: { type: Boolean, required: true },
    event_introducer_text: { type: String, required: true },
    event_questionnaires: { type: Array, required: true },
    use_introducer_tell: { type: Boolean, required: true },
    use_introducer_name: { type: Boolean, required: true },
    use_introducer_adress: { type: Boolean, required: true },
    send_csv_path: { type: String, required: true },
    eventer_mail: { type: String, required: true },
    edit_audience_path: { type: String, required: true },
    recapcha_api_key: { type: String, required: true },
    refund_message: { type: String, required: true },
    main_event_play_date: { type: String, required: true },
    event_place: { type: String, required: true },
    event_url: { type: String, required: true },
    contact_info: { type: String, required: true },
    inquiry_url: { type: String, required: true },
    is_cooperator: { type: Boolean, required: true },
    is_can_not_refund_event: { type: Boolean, required: true },
    exclamation_img_path: { type: String, required: true },
    comment_img_path: { type: String, required: true },
    block_audience_path: { type: String, required: true },
    send_pdf_path: { type: String, required: true },
    use_contact_form: { type: Boolean, required: true },
    contact_mails: { type: String, required: true },
    contact_tels: { type: String, required: true },
    contact_urls: { type: String, required: true },
  },
  data() {
    return {
      isModalOpen: false
    };
  },
  methods: {
    openModal() {
      this.isModalOpen = true;
    },
  },
};
</script>

<style lang="scss" scoped>
$break-point: 768px;
.checkboxes-and-audience-list-table-wrapper {
  display: flex;

  .audience-list-table-wrap {
    max-width: calc(100% - 190px);
    margin-top: 15px;

    @media screen and (max-width: 1000px) {
      max-width: calc(100% - 120px);
    }

    @media screen and (max-width: $break-point) {
      max-width: 100%;
    }
  }
}
</style>
